import React from "react";

import FolderIcon from "@mui/icons-material/FolderOutlined";

import ListDetailView, { ListViewItem, withListDetail } from "../components/ListDetailView";

export const ProjectsIcon = FolderIcon;

const ListItem = ({ data, ...props }) => {
    return <ListViewItem {...props} mainText={data.name} secondaryText={[data.typeName, data.idNumber]} mainValue="9876,- Kč" secondaryValue={data.date} />;
};

const ProjectsPage = withListDetail(() => {
    return <ListDetailView title="Projekty" renderItem={(props) => <ListItem {...props} />} />;
});

export default ProjectsPage;
